<template>
	<div id="news" class="page">
		<div class="focus">
			<swiper :options="swiperOption">
				<swiper-slide v-for="(item,index) in attachments" :key="index"><a v-bind:href="item.url"><img :src="item.image" class="swiper-img"></a></swiper-slide>
			</swiper>
		</div>
		<div class="button-group">
			<router-link to="/addprize">
				<div>
					<i class="iconfont icon-weibiaoti-_huabanfuben"></i>
					发奖状
				</div>
			</router-link>
			<router-link to="/prize">
				<div>
					<i class="iconfont icon-jiangzhuang"></i>
					我的奖状
				</div>
			</router-link>
			<router-link to="/yuyue">
				<div>
					<i class="iconfont icon-reserve"></i>
					预约车辆
				</div>
			</router-link>
			<router-link to="/paiche">
				<div>
					<i class="iconfont icon-cheliangpaiban"></i>
					指派车辆
				</div>
			</router-link>
			<router-link to="/poster">
				<div>
					<i class="iconfont icon-jingmeihaibao"></i>
					招生海报
				</div>
			</router-link>
		</div>
		<div class="button-group button-group2" style="padding-bottom:10px;">
			
		</div>
		<div class="nav-bar">
			<div v-on:click="changeType(0)" v-bind:class="{active:!type}">学车经验</div>
			<div v-on:click="changeType(1)" v-bind:class="{active:type}">精选</div>
			<div class="txt">赞赏总额<font color="#fd693b">{{total_money}}</font>元</div>
		</div>
		<div class="null-box" v-if="loaded && newsList.length<1">
			<i class="iconfont icon-ico_meiyoushuju"></i>
			<p>没有内容</p>
		</div>
		<div title="加载"
			v-infinite-scroll="loadMore"
			infinite-scroll-disabled="loading"
			infinite-scroll-distance="50">
			<div class='news-box'>
			<router-link :to="{path:'/newsinfo',query:{id:item.id}}" v-for="(item,index) in newsList" :key="index">
				<div class='news-list'>
					<div class="lft" v-if="item.image"><img v-bind:src="item.image"/></div>
					<div class="right">
						<div class="title">{{item.subject}}</div>
						<div class="other">
							<div>
								<i class="iconfont icon-comiischakanshu"></i>{{item.view}}
							</div>
							<div style="text-align:right;">
								<i class="iconfont icon-qianbao"></i>打赏：￥{{item.total_money}}
							</div>
						</div>
					</div>
				</div>
			</router-link>
			</div>
			<p v-show="loading" class="loading-tips" style="text-align:center;">
				<wv-spinner type="snake" color="#444" :size="24"/>
			</p>
		</div>
	</div>
</template>

<script>
import { Toast } from 'we-vue'
export default {
  data () {
    return {
		loaded:false,
		newsList:[],
		attachments:[],
		loading:false,
		page:1,
		swiperOption:{
			slidesPerView: 'auto',
			centeredSlides:true,
			spaceBetween: 10,
			loop:true,
			speed:600, //config参数同swiper4,与官网一致
			autoplay:true
		},
		swiperOptionCompencate:{
			direction : 'vertical',
			slidesPerView: 'auto',
			centeredSlides:true,
			spaceBetween: 0,
			loop:true,
			speed:600, //config参数同swiper4,与官网一致
			autoplay:true
		},
		userInfo:{},
		type:0,
		total_money:''
	}
  },
  mounted () {
	
  },
  created(){
		this.userInfo = this.$store.state.userInfo;
		this.$https.post("/api/adv/newsadv",this.$qs.stringify({
			token:this.$store.state.token
		})).then((res) => {
			this.attachments = res.data.data
			console.log(this.attachments)
		});
  },
  methods: {
		changeType(type){
			this.type = type
			this.reLoad()
		},
		reLoad(){
			this.newsList = []
			this.page = 1
			this.loaded = false
			this.loadMore()	
		},
		loadMore(){
			if(this.loaded){
				return false
			}
			this.loading = true
			this.$https.post("/api/news/lists",this.$qs.stringify({
				token:this.$store.state.token,
				page:this.page,
				type:this.type
			})).then((res) => {
				if(res.data.data.lists.length < 1){
					this.loaded = true;
				}
				for(var n in res.data.data.lists){
					this.newsList.push(res.data.data.lists[n])
				}
				this.total_money = res.data.data.total_money
				this.loading = false
				this.page++;
			}).catch(() => {
				
			});
		}
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#news{
		background-color:#f4fcff;
		min-height:100vh;
	}
	.focus,.focus img{
		height:120px;
		width:100%;
	}
	.button-group{
		display:flex;
		display:-webkit-flex;
		padding:3vw 0px;
		padding-bottom:0px;
		background-color:#FFFFFF;
	}
	.button-group > a{
		flex:1;
		font-size:14px;
		color:#898989;
		-webkit-flex:1;
		text-align:center;
	}
	.button-group > a i{
		width:13vw;
		height:13vw;
		line-height:13vw;
		background-color:#f55a00;
		border-radius:7vw;
		color:#FFFFFF;
		display:block;
		margin:auto;
		font-size:6vw;
	}
	.button-group > a:nth-child(1) i{
		background-color:#31bd49;
	}
	.button-group > a:nth-child(2) i{
		background-color:#8a6ff5;
	}
	.button-group > a:nth-child(3) i{
		background-color:#b1b100;
	}
	.button-group > a:nth-child(4) i{
		background-color:#1894ff;
	}
	.button-group.button-group2 > a:nth-child(1) i{
		background-color:#00d8ce;
	}
	.button-group.button-group2 > a:nth-child(2) i{
		background-color:#16c101;
	}
	.button-group.button-group2 > a:nth-child(3) i{
		background-color:#02c3ef;
	}
	.nav-bar{
		margin-top:10px;
		background-color:#FFFFFF;
		font-size:4.2vw;
		padding:3vw;
		padding-bottom:0vw;
		display:flex;
		display:-webkit-flex;
		border-bottom:1px solid #EEEEEE;
	}
	.nav-bar div{
		line-height:7vw;
		height:10vw;
		flex:1;
		-webkit-flex:1;
		text-align:center;
		color:#5d5d5d;
	}
	.nav-bar div.active{
		border-bottom:2px solid #fd693b;
	}
	.nav-bar div.txt{
		font-size:12px;
		color:#898989;
	}
	.news-list{
		padding:0px 3vw;
		display:flex;
		display:-webkit-flex;
		background-color:#FFFFFF;
		border-bottom:1px solid #EEEEEE;
	}
	.news-list > div.right{
		flex:1;
		padding:3vw 0px;
		-webkit-flex:1;
		padding-left:3vw;
		color:#5d5d5d;
	}
	.news-list > div.right .title{
		height:13vw;
		font-size:4.2vw;
	}
	.news-list > div.right .other{
		display:flex;
		display:-webkit-flex;
	}
	.news-list > div.right .other{
		color:#a3a2a2;
		font-size:3.6vw;
	}
	.news-list > div.right .other i{
		margin-right:10px;
	}
	.news-list > div.right .other div{
		flex:1;
		-webkit-flex:1;
	}
	.news-list .lft{
		padding:3vw 0px;
		border-bottom:1px solid #EEEEEE;
		width:25vw;
	}
	.news-list .lft img{
		width:100%;
		height:18vw;
	}
</style>


// WEBPACK FOOTER //
// src/components/News.vue